module.exports = __webpack_public_path__ + "img/1-7.6fc6a34b.png";